import axios from 'axios'

//var baseURL = window.location.protocol + "//" + window.location.hostname + ":8081" + "/" + window.location.pathname + window.location.search

const instance = axios.create({
//      baseURL: baseURL,
//        timeout: 1000,
//        headers: {'X-Custom-Header': 'foobar'}
});

//instance.setAuth = (

//module.exports = instance

export default instance
